import './head.css'

function Head() {

    return(
        <header>
            <div className="logo">
                <div className="logo_block">
                </div>
                <div className="logo_block_two">
                </div>
                <span className="logo_name">
                    Cards
                </span>
            </div>
        </header>
    )
}

export default Head